import FreeCoupan from "../Free-Coupan/freecoupan";
import FreeInstallation from "../Free-Installation/freeinstallation";

import React, { useState } from "react";

const ClaimFree = () => {
    const [showInstallation, setShowInstallation] = useState(false);
    return (
        <section className="dashbg-color">

            <div className="row justify-content-center">
                
                <div>
                    {showInstallation ?
                        <FreeInstallation showInstallation={showInstallation} setShowInstallation={setShowInstallation}/> : <FreeCoupan showInstallation={showInstallation} setShowInstallation={setShowInstallation}/>}
                </div>
            </div>
        </section>
    );
}

export default ClaimFree;